
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Divider, Backdrop
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA} from '../../components/form';
import moment from 'moment';
import { getFormState } from '../../../helpers/form';
import dayjs from 'dayjs';
import CircularProgress from '@mui/material/CircularProgress';

import { SelectA, FileUploadA, DatePickerA } from '../../components/form';

const API_HOST = CONFIG.modules['accounts'].host
const API_HOST_CRM = CONFIG.modules['crm'].host



const markStyle = { borderRadius: 1,ml: 2, minWidth: 300, background: '#F3D55B',mb: 3 ,height:40, pl:2, display:'flex', alignItems:'center' }

const wrap = { display: 'flex', alignItems: 'center', justifyContent:'space-between' }
const text2 = {fontSize: '.8em'}

export const AllocationUpload = (props) => {
    const { roles, user, users, Designations, Departments, Languages, Districts, Campaigns, TaskTypes } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))
    const [campaign, setCampaign] = useState('')
    const [campaignMap, setCampaignMap] = useState({})
    const [tasktype, setTaskType] = useState(null)
    const [uploading, setUploading] =useState(false)
    const [uploaded, setUploaded] = useState(null)
    const [month, setMonth] = useState(dayjs())
    const [type, setType] = useState('newdata')

    useEffect(() => {
        if (Campaigns) {
            setCampaignMap(Campaigns.reduce((a, c) => {
                a[c._id] = c
                return a;
            }, {}))
            setCampaign(Campaigns[0]._id)
        }
    }, [Campaigns])

    useEffect(()=>{
        if(TaskTypes) {
            setTaskType(TaskTypes.find(e=>e.name == 'Outbound')._id)
        }
    },[TaskTypes])

    const handleFileUpload = (value,event) => {
        
        const file = value[0]
        const formData = new FormData();
        formData.append('file', file);
        setUploading('Uploading data................... Please Wait')
    
        axios.post(API_HOST_CRM + '/upload-data?campaign='+campaign+'&tasktype='+tasktype+`&type=${type}`, formData)
        .then((resp) => {
            if (resp.data && resp.data.success) {
                setUploaded(resp.data.data.upload)
            }
            event.target.value = null
            setUploading(false)
        }).catch((e) => {
            event.target.value = null
            setUploading(false)
            console.log(e)
        })
      };

      const handleSave = () => {
        setUploading('Saving uploaded data................... Please Wait')
        axios.post(API_HOST_CRM + '/save-uploaded-data', {
            campaign, tasktype, 
            fileKey:uploaded.fileKey, 
            id:uploaded._id,
            type
        })
        .then((resp) => {
            if (resp.data && resp.data.success) {
                setUploaded({...resp.data.data.upload, saved: true})
            } else {
                setUploaded(null)
            }
            
            setUploading(false)
        }).catch((e) => {
            setUploaded(null)
            setUploading(false)
            console.log(e)
        })
      }


    return (
        <>
            {
                uploading &&
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={true}
                    
                    >
                        <Box sx={{display:'flex', flexDirection: 'column', alignItems:'center'}}>
                        <CircularProgress color="inherit" />
                        <Typography variant='p'>{uploading} </Typography>
                    
                        </Box>
                        
                    </Backdrop>
            }
            {/* <ToolBar name={active} /> */}
            <Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', mt: 3, }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', }}>
                            {/* <Typography variant='p' sx={{ mb: 3 }}>Campaign</Typography> */}
                            <Box sx={{ ml: 2, display: 'flex', minWidth: 300 }}>
                                <SelectA field={
                                    {
                                        type: 'select',
                                        label: 'Campaign',
                                        option: { key: 'Campaigns', value: '_id', label: 'name' },
                                        name: 'campaign'
                                    }
                                } 
                                disabled={!!uploaded}
                                data={{ Campaigns }} onChange={(name, value, multiple) => {
                                    setCampaign(value)
                                }} value={campaign} />
                            </Box>
                            <Typography variant='p' sx={{ mb: 3 }}></Typography>
                            <Box sx={{ ml: 2, display: 'flex', minWidth: 300 }}>
                                <SelectA field={
                                    {
                                        type: 'select',
                                        label: 'Type',
                                        option: { key: 'Types', value: '_id', label: 'name' },
                                        name: 'type'
                                    }
                                } 
                                disabled={!!uploaded}
                                data={{ Types: [
                                    {
                                        _id: 'newdata',
                                        name: 'New Data'
                                    },
                                    // {
                                    //     _id: 'olddata',
                                    //     name: 'Old Data'
                                    // },
                                    {
                                        _id: 'sankalp',
                                        name: 'Sankalp'
                                    },
                                    {
                                        _id: 'ECD',
                                        name: 'ECD'
                                    }
                                ] }} onChange={(name, value, multiple) => {
                                    setType(value)
                                }} value={type} />
                            </Box>
                        </Box>
                        <Box sx={{ display: 'flex' }}>
                            {
                                !uploaded&&
                                <FileUploadA field={
                                    {
                                        type: 'file',
                                        label: 'Upload Dataset',
                                        name: 'new-data-set',
                                        accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
                                    }
                                } data={{  }} onChange={(e,name, value, multiple) => {
                                    handleFileUpload(value, e)
                                }} value={campaign} />
                            }
                            {
                                uploaded&&
                                <Typography variant='p'>File Uploaded SuccessFully!</Typography>
                            }
                            
                        </Box>

                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', mt: 3 }}>
                        {uploaded &&
                        
                        <>
                       
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant='p' sx={{ mb: 3 }}>New dataset for the month of</Typography>
                            <Box sx={{ ml: 2, minWidth: 300 }}>
                                <DatePickerA
                                    field={
                                        {
                                            type: 'date',
                                            label: '',
                                            name: 'month',
                                            defaultValue: dayjs()
                                        }
                                    }
                                    onChange={(name, value)=>{
                                        setMonth(value)
                                    }}
                                    data={{}}
                                    value={month}
                                />
                            </Box>


                        </Box>
                        {
                            uploaded.saved &&
                            <>
                              <Box sx={wrap}>
                            <Typography variant='p' sx={{ mb: 3 }}>Records saved</Typography>
                            <Box sx={markStyle}>
                                <Typography variant='p' sx={text2}>{uploaded.willSave||0} saved</Typography>
                            </Box>
                        </Box>
                            <Box sx={wrap}>
                            <Typography variant='p' sx={{ mb: 3 }}>Duplicate records removed</Typography>
                            <Box sx={markStyle}>
                                <Typography variant='p' sx={text2}>{uploaded.duplicateRecords||0} Records marked as duplicates</Typography>
                            </Box>
                        </Box>
                        <Box sx={wrap}>
                            <Typography variant='p' sx={{ mb: 3 }}>Invalid records removed</Typography>
                            <Box sx={markStyle}>
                                <Typography variant='p' sx={text2}>{uploaded.invalidNumbers||0} Records with invalid numbers</Typography>
                            </Box>
                        </Box>
                        <Box sx={wrap}>
                            <Typography variant='p' sx={{ mb: 3 }}>New dataset with valid records</Typography>
                            <Box sx={markStyle}>
                                <Typography variant='p' sx={text2}>{uploaded.withValidRecords || 0} valid records</Typography>
                            </Box>
                        </Box>
                            </>
                        }

                        
                        <Box sx={{display:'flex', flexDirection:'row-reverse'}}>
                           {
                            uploaded&&!uploaded.saved&&
                            <>
                            <Button variant="contained" sx={{ mt: 6, float: 'right', mb: 3, pl:4, pr:4, ml:3 }} onClick={()=>{
                                setUploaded(null)
                            }}>Cancel</Button>
                            <Button variant="contained" sx={{ mt: 6, float: 'right', mb: 3, pl:4, pr:4 }} onClick={()=>{
                                handleSave()
                            }}>Save</Button>
                            </>
                           }
                           {
                            uploaded.saved &&
                            <Button variant="contained" sx={{ mt: 6, float: 'right', mb: 3, pl:4, pr:4, ml:3 }} onClick={()=>{
                                setUploaded(null)
                            }}>Done</Button>
                           }
                            

                    
                        </Box>
                        </>}
                    </Box>
                </Box>
            
                <Divider sx={{mt:4}}/>

            </Box>

        </>
    )
}